import { useMemo, useState } from "react";
import { constraints } from "../../auth/AuthFormComponents";
import { baseEndPoint, stringTo2DP } from "../../utils";

import "../../../component_styles/landing/homepage/scam_recovery.css"
import SubmitBtn from "../../add_ons/SubmitBtn";

const telPattern=/^\+[1-9]\d{6,14}$/
const initialInputs = {
  email: "",
  fullname: "",
  phonenumber: "",
  type: "",
  amount: ""
};
const ScamRecovery = () => {
    const [loading, setLoading] = useState(false)
    const [formError, setFormError] = useState('')
    const [formSuccess, setFormSuccess] = useState('')
    const [inputs, setInputs] = useState(initialInputs)
    const [inputsErr, setInputsErr] = useState({
        email: "",
        fullname: "",
        phonenumber: "",
        type: "",
        amount: ""
    })
    const [inputsValidity, setInputsValidity] = useState({
        email: false,
        fullname: false,
        phonenumber: false,
        type: false,
        amount: false
    })

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setInputs(prev=>({...prev,[name]:value}))

        const err = {}
        const validity = {}

        switch(name){
            case 'email':
                // email validation
                const emailValid = constraints.emailRegex.test(value)
                err['email'] = emailValid ? "" : "Input an correct email address."
                validity['email'] = emailValid
            break;
            case 'fullname':
                // fullname validation
                const fullnameValid = constraints.fullnameRegex.test(value)
                err['fullname'] = fullnameValid ? "" : "Input fullname."
                validity["fullname"] = fullnameValid
            break;
            case 'phonenumber':
                // phonenumber
                const phonenoValid = telPattern.test(value)
                err['phonenumber'] = phonenoValid ? "" : "Input a valid phone number."
                validity["phonenumber"] = phonenoValid
            break;
            case 'type':
                // scam type
                const typeValid = value !== ''
                err['type'] = typeValid ? "" : "Input a value."
                validity["type"] = typeValid 
            break;
            case 'amount':
                // amount
                const _amount = stringTo2DP(value)
                const amountValid = Number(_amount) > 0
                err['amount'] = amountValid ? "" : "Input a valid amount."
                validity["amount"] = amountValid
            break;
            default:
                break; 
        }

        setInputsValidity(validity)
        setInputsErr(err)
    }

    const allInputsValid = useMemo(()=>
        !(Object.values(inputsValidity).includes(false))
        ,[inputsValidity])
    
    const handleSubmit = async () => {
        if(!allInputsValid || loading)return
        setLoading(true)
        setFormError('')
        setFormSuccess('')
        await baseEndPoint.post("/api/scam-recovery-request/",{
            ...inputs
        }).then(()=>{
            setFormSuccess("Recovery successfully requeted.")
            setInputs(initialInputs);
        }).catch((e)=>{
            const detail = e?.response?.data?.detail
            setFormError(detail||'An error occured while requesting recovery.')
        }).finally(()=>{
            setLoading(false)
        })
    }
    
    return (
        <section 
            className="scam-recovery"
            style={{backgroundImage: "url(https://res.cloudinary.com/derzcse6f/image/upload/v1761038161/scam-recovery_qawkfc.jpg)"}}
        >
            <div className="textual">
                <div role="heading" aria-level={2}>
                    “Ever been a victim of a scam? Let's restore hope — one case at a time.”
                </div>
                <p style={{fontSize: "18px"}}>Our dedicated team has successfully helped victims reclaim over <b>$2 million</b> in lost funds — standing firm against online fraud and financial exploitation worldwide.</p>
            </div>
            <div role="form">
                <p>Meet our dedicated team of experts to recover your hard earned money</p>
                {/* fullname */}
                <div>
                    <input 
                        name="fullname" 
                        type="text" 
                        placeholder="Full name" 
                        onChange={handleChange}
                        disabled={loading}
                    />
                    {inputsErr.fullname && (
                        <div className="input-error">{inputsErr.fullname}</div>
                    )}
                </div>
                {/* email */}
                <div>
                    <input 
                        name="email" 
                        type="email" 
                        placeholder="Email" 
                        onChange={handleChange}
                        disabled={loading}
                    />
                    {inputsErr.email && (
                        <div className="input-error">{inputsErr.email}</div>
                    )}
                </div>
                {/* phone number */}
                <div>
                    <input 
                        name="phonenumber" 
                        type="text" 
                        placeholder="+14155552671" 
                        pattern={telPattern.toLocaleString().slice(1,-1)}
                        title="Valid US phone like 212-555-1234 or +1 212-555-1234"
                        onChange={handleChange}
                    />
                    {inputsErr.phonenumber && (
                        <div className="input-error">{inputsErr.phonenumber}</div>
                    )}
                </div>
                {/* scam type */}
                <div>
                    <select id="scam-type" name="type" 
                        onChange={handleChange}
                        style={{padding: "0.5rem", borderRadius: "6px", border: "1px solid #ccc"}}
                        disabled={loading}
                    >
                        <option value="">-- Select Scam Type --</option>
                        <option>Investment Scam</option>
                        <option>Cryptocurrency Scam</option>
                        <option>Online Shopping Fraud</option>
                        <option>Romance / Relationship Scam</option>
                        <option>Charity or Donation Scam</option>
                        <option>Phishing / Email Fraud</option>
                        <option>Business Email Compromise</option>
                        <option>Tech Support Scam</option>
                        <option>Lottery / Prize Scam</option>
                        <option>Identity Theft</option>
                        <option>Real Estate / Rental Fraud</option>
                        <option>Job Offer Scam</option>
                        <option>Social Media Scam</option>
                        <option>Banking or Card Fraud</option>
                        <option>Other</option>
                    </select>
                </div>
                {inputsErr.type && (
                    <div className="input-error">{inputsErr.type}</div>
                )}
                {/* amount lost */}
                <div>
                    <input 
                        type="text" 
                        name="amount" 
                        placeholder="amount lost"
                        onChange={handleChange}
                        disabled={loading}
                    />
                    {inputsErr.amount && (
                        <div className="input-error">{inputsErr.amount}</div>
                    )}   
                </div>


                {/*form error*/}
                {
                    formError && (<div className="input-error form-error">
                        {formError}
                    </div>)
                }
                {/* form success */}
                {formSuccess && (
                    <div className="form-success">{formSuccess}</div>
                )}

                <SubmitBtn
                    loading={loading}
                    disabled={!allInputsValid}
                    handleSubmit={handleSubmit}
                    btnText={loading?"requesting...":"Get support"}
                />
            </div>
        </section>
    )
}

export default ScamRecovery;